module.exports = __webpack_public_path__ + "img/004.c44067c8.svg";